import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000'
    },
    colorsDefault: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    colorsHistoryKey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imgAlphaBase64: '',
      colorsHistory: JSON.parse(localStorage.getItem(this.colorsHistoryKey)) || []
    };
  },
  created: function created() {
    this.imgAlphaBase64 = this.createAlphaSquare(4).toDataURL();
  },
  destroyed: function destroyed() {
    this.setColorsHistory(this.color);
  },

  methods: {
    selectColor: function selectColor(color) {
      this.$emit('selectColor', color);
    },
    setColorsHistory: function setColorsHistory(color) {
      if (!color) {
        return;
      }
      var colors = this.colorsHistory;
      var index = colors.indexOf(color);
      if (index >= 0) {
        colors.splice(index, 1);
      }
      if (colors.length >= 8) {
        colors.length = 7;
      }
      colors.unshift(color);
      this.colorsHistory = colors;
      localStorage.setItem(this.colorsHistoryKey, _JSON$stringify(colors));
    }
  }
};